import React, { Component } from 'react';
import API from '../../api/api';
import './liveDraw.less';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import { Tabs, Button, Input, DatePicker, Select, message, ConfigProvider } from 'antd';
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

class LiveInfoList extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        activeKey: '1',
        loading: false,
        phaseList: [],
    }

    componentDidMount() {
        if (this.getQueryString('activityId') && this.getQueryString('activityId') != 'null') {
            this.setState({
                activityId: this.getQueryString('activityId')
            }, () => {
                this.phaseList()
            })
        }
    }

    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
    // componentWillReceiveProps() {
    //     this.getListData();
    // }


    TabOnChangeCallback(key) {
        this.setState({ activeKey: key })
    }

    async onEdit(targetKey, action) {
        let { phaseList, activityId } = this.state;
        if (action == 'remove') {
            let phaseId = phaseList[Number(targetKey) - 1].phaseId;
            phaseList.splice(targetKey - 1, 1);
            console.log('phaseList', phaseList)
            this.setState({ phaseList, activeKey: String(phaseList.length) })
            if (phaseId) {
                let result = await API.phaseDelete({ phaseId });
                if (result.status == 1) {
                    message.success('删除成功');
                }
            }
        }
    }

    async phaseList() {
        let result = await API.phaseList({ activityId: this.state.activityId });
        if (result.status == 1) {
            if (result.data.phaseList.length > 0) {
                this.setState({ phaseList: result.data.phaseList })
            } else {
                let phaseList = [
                    {
                        phaseId: '',
                        phaseNo: '1',
                        phaseName: '',
                        lotteryTime: '',
                        status: '0',// 0,"未开始" (1,"开奖中"), (2,"已开奖"),
                        articleId: '',
                        prizeList: [
                            {
                                prizeId: '',
                                prizeLevelName: `${this.numberBig(1)}等奖`, // (0,"未中奖"),(1,"已中一等奖"),(2,"已中二等奖"),(3,"已中三等奖"),
                                prizeName: '',
                                sendPrizeType: '0', // (0,"线下发放"),(1,"线上发放"),
                                templateId: '',
                                status: '0', // (0,"未开始"),(1,"抽取中"),(2,"抽奖结束"),
                                currSendLotteryNo: [''], // 当前正在推送的抽奖号
                            }
                        ]
                    }
                ]

                this.setState({ phaseList })
            }
        }
    }

    InputItemChange(index, prizeListIndex, target, e) {
        let value = e.target.value.trim();//不能缺少的声明 eval表达式需要用到value
        let { phaseList } = this.state;

        if (prizeListIndex == -1) {
            console.log('value', value)
            phaseList[index][target] = value;
        } else {
            phaseList[index].prizeList[prizeListIndex][target] = value;
        }
        this.setState({ phaseList })
    }

    onSearchDateChange(index, date) { //筛选条件 ：时间范围
        const { phaseList } = this.state;
        if (date && date.valueOf()) {
            phaseList[index].lotteryTime = parseInt(date.valueOf() / 1000);
            this.setState({ phaseList })
        }
    }

    onSelectChange(index, prizeListIndex, target, value) {//下拉框更改
        let { phaseList } = this.state;
        phaseList[index].prizeList[prizeListIndex][target] = value
        this.setState({ phaseList });
    }

    handleTableChange = (pagination, filters, sorter) => {
        const {
            activeKey,
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        } = this.state;
        let conditionArr = ['liveSearchCondition', 'authSearchCondition', 'freezeSearchCondition', 'rewardSearchCondition', 'recGoodSearchCondition']
        eval(conditionArr[activeKey - 1] + '.pageIndex=' + pagination.current)
        this.setState({
            pagination,
            liveSearchCondition,
            freezeSearchCondition,
            authSearchCondition,
            recGoodSearchCondition,
            rewardSearchCondition
        }, () => {
            this.getListData();
        });
    };
    freezeLive() {
        const { freezeInfoModal } = this.state;
        let param = {
            toUserId: freezeInfoModal.toUserId,
            reason: freezeInfoModal.reason,
            isAction: 1
        }
        console.log(param)
        this.liveFreeze(param)
    }
    handleAddModalCancel(type) {//添加或编辑对话框点击取消后
        const { authInfoModal, freezeInfoModal } = this.state;
        if (type == 'auth') {
            authInfoModal.show = false;
        }
        else if (type == 'freeze') {
            freezeInfoModal.show = false;
            freezeInfoModal.reason = '';
            freezeInfoModal.toUserId = '';
        }
        this.setState({ authInfoModal, freezeInfoModal })
    }
    clearNull(obj) {//删除对象中为空的属性
        for (let key in obj) {
            if (obj[key] === '') {
                delete (obj[key])
            }
        }
        return obj
    }
    accessOn = async (param) => {//认证通过状态
        let result = await API.liveCheck(param);
        const { authInfoModal } = this.state;
        authInfoModal.status = param.status;
        this.setState({ authInfoModal })
        if (result.status == 1) {
            let msg = param.status == 20 ? '已认证通过' : '已拒绝认证通过';
            message.success(msg)
            this.getListData();
            this.getWaitForCheck();
            return;
        }
        message.error(result.msg)
    }

    numberBig(num) {
        const data = {
            '0': '零',
            '1': '一',
            '2': '二',
            '3': '三',
            '4': '四',
            '5': '五',
            '6': '六',
            '7': '七',
            '8': '八',
            '9': '九',
        };
        return String(num).split('').map(v => data[v] || v).join('');
    }

    addPhase() {
        let { phaseList } = this.state;
        let phaseNo = phaseList && phaseList.length > 0 ? (Number(phaseList[phaseList.length - 1].phaseNo) + 1) : 1;
        console.log('phaseNo', phaseNo)
        let addPane = {
            phaseId: '',
            phaseNo,
            phaseName: '',
            lotteryTime: '',
            status: '0',// 0,"未开始" (1,"开奖中"), (2,"已开奖"),
            articleId: '',
            prizeList: [
                {
                    prizeId: '',
                    prizeLevelName: `${this.numberBig(1)}等奖`, // (0,"未中奖"),(1,"已中一等奖"),(2,"已中二等奖"),(3,"已中三等奖"),
                    prizeName: '',
                    sendPrizeType: 0, // (0,"线下发放"),(1,"线上发放"),
                    templateId: '',
                    status: '0',
                }
            ]
        }
        phaseList.push(addPane);
        this.setState({ phaseList }, () => {
            this.setState({ activeKey: String(phaseList.length) })
        })
    }

    async prizeDelete(index, prizeListIndex, prizeId) {
        let { phaseList } = this.state;
        phaseList[index].prizeList.splice(prizeListIndex, 1);
        this.setState({ phaseList })
        if (prizeId) {
            let result = await API.prizeDelete({ prizeId })
            if (result.status == 1) {
                message.success('删除成功');
                return;
            }
            message.error(result.msg);
        }
    }

    addPrize(index) {
        let { phaseList } = this.state;
        phaseList[index].prizeList.push({
            prizeId: '',
            prizeLevelName: `${this.numberBig(phaseList[index].prizeList.length + 1)}等奖`,
            prizeName: '',
            sendPrizeType: '0', // (0,"线下发放"),(1,"线上发放"),
            templateId: '',
            status: '0', // (0,"未开始"),(1,"抽取中"),(2,"抽奖结束"),
        })
        this.setState({ phaseList })
    }

    async phaseEdit(index) {
        let { phaseList, activityId } = this.state;
        console.log('phaseList', phaseList)
        let params = phaseList[index];
        params.prizeList = JSON.stringify(params.prizeList);
        params.activityId = activityId;
        let result = await API.phaseEdit(params)
        if (result.status == 1) {
            message.success('保存成功');
            this.phaseList({ activityId });
            return;
        }
        message.error(result.msg);
    }

    async queryPushUrl(params) {
        let result = await API.queryPushUrl(params)
        if (result.status == 1) {
            if (result.data && result.data.pushUrl) {
                return result.data.pushUrl;
            }
            message.error('获取失败');
            return
        }
        message.error(result.msg);
    }

    async phaseLotteryAction(index, start) {
        let { phaseList } = this.state;
        let result = await API.phaseLotteryAction({
            phaseId: phaseList[index].phaseId,
            start
        })
        if (result.status == 1) {
            if (start == 1) {
                message.success('已启动');
            } else {
                message.success('已完成');
            }
            return;
        }
        message.error(result.msg);
    }

    async startLottery(index, prizeListIndex, isFirst) {
        let { phaseList } = this.state;
        let lotteryNoList = phaseList[index].prizeList[prizeListIndex].lotteryNoList;
        if (!isFirst && lotteryNoList[lotteryNoList.length - 1].length != 7) {
            message.error('当前号码未抽取完成');
            return
        }
        let result = await API.startLottery({
            prizeId: phaseList[index].prizeList[prizeListIndex].prizeId,
            isFirst
        })
        if (result.status == 1) {
            message.success('开始抽取');
            if (!isFirst) {
                phaseList[index].prizeList[prizeListIndex].lotteryNoList.push('');
                this.setState({ phaseList })
            }
            return;
        }
        message.error(result.msg);
    }

    async submitLotteryNum(lotteryNoListItem, prizeId, index, prizeListIndex, lotteryNoListIndex) {
        let result = await API.submitLotteryNum({
            num: lotteryNoListItem ? (lotteryNoListItem.length + 1) : 1,
            prizeId
        })
        if (result.status == 1) {

            let { phaseList } = this.state;
            if (!lotteryNoListItem && lotteryNoListIndex == -1) {
                phaseList[index].prizeList[prizeListIndex].lotteryNoList = [result.data.lotteryNo];
                message.success(`已确定${1}位`);
            } else {
                let lotteryNo = phaseList[index].prizeList[prizeListIndex].lotteryNoList[lotteryNoListIndex];
                phaseList[index].prizeList[prizeListIndex].lotteryNoList[lotteryNoListIndex] = lotteryNo + result.data.lotteryNo;
                message.success(`已确定${lotteryNo.length + 1}位`);
            }
            this.setState({ phaseList })
            return;
        }
        message.error(result.msg);
    }

    async copyText(index) {
        const { phaseList } = this.state;
        if (!phaseList[index].articleId) {
            message.info('请输入文章ID')
            return
        }
        let pushUrl = await this.queryPushUrl({ articleId: phaseList[index].articleId });
        if (!pushUrl) return;
        this.setState({ pushUrl }, () => {
            let copyDOM = document.getElementById("pushUrl");  //需要复制文字的节点  
            let range = document.createRange(); //创建一个range
            window.getSelection().removeAllRanges();   //清楚页面中已有的selection
            range.selectNodeContents(copyDOM);    // 选中需要复制的节点    
            window.getSelection().addRange(range);   // 执行选中元素
            let successful =
            document.execCommand('copy') ?
                `复制成功` :
                `复制失败，请手动复制`;
            message.success(successful)
        })
    }

    render() {

        const {
            activeKey,
            phaseList,
            pushUrl,
        } = this.state;

        console.log('activeKey', activeKey)
        return (
            <ConfigProvider locale={zhCN}>
                <div className="LiveInfoListPane">
                    <Button className='addPhase' onClick={this.addPhase.bind(this)}>添加活动</Button>
                    {
                        phaseList && phaseList.length > 0 &&
                        <Tabs className='phaseListTabs' activeKey={activeKey} defaultActiveKey={'1'} hideAdd type="editable-card" onEdit={this.onEdit.bind(this)} onChange={this.TabOnChangeCallback.bind(this)}>
                            {
                                phaseList.map((item, index) => {
                                    return (
                                        <TabPane className='phaseListTabPane' tab={`第${item.phaseNo}期`} key={index + 1}>
                                            <div className="phaseModel">
                                                <div className='phaseInfo'>
                                                    <Input className='phaseName' value={item.phaseName} onChange={this.InputItemChange.bind(this, index, '-1', 'phaseName')} placeholder="名称"></Input>
                                                    <div className='prizeTitle'>
                                                        <div>奖品</div>
                                                        <Button className='addPrize' onClick={this.addPrize.bind(this, index)}>添加奖品</Button>
                                                    </div>
                                                    {
                                                        item.prizeList.map((prizeListItem, prizeListIndex) => {
                                                            return (
                                                                <div className='prizeListItem' key={prizeListIndex}>
                                                                    <Input className='prizeLevelName' value={prizeListItem.prizeLevelName} onChange={this.InputItemChange.bind(this, index, prizeListIndex, 'prizeLevelName')} placeholder=""></Input>
                                                                    <Input className='prizeName' value={prizeListItem.prizeName} onChange={this.InputItemChange.bind(this, index, prizeListIndex, 'prizeName')} placeholder="奖品名称"></Input>
                                                                    <Select className="selectBlock" value={prizeListItem.sendPrizeType + ''} onChange={this.onSelectChange.bind(this, index, prizeListIndex, 'sendPrizeType')}>
                                                                        <Option value="0">线下发放</Option>
                                                                        <Option value="1">线上发放</Option>
                                                                    </Select>
                                                                    {
                                                                        prizeListItem.sendPrizeType == 1 &&
                                                                        <Input className='templateId' value={prizeListItem.templateId} onChange={this.InputItemChange.bind(this, index, prizeListIndex, 'templateId')} placeholder="奖券ID"></Input>
                                                                    }
                                                                    {
                                                                        prizeListIndex != 0 &&
                                                                        <Button type="danger" onClick={this.prizeDelete.bind(this, index, prizeListIndex, prizeListItem.prizeId)}>删除</Button>
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    <div className='lotteryTime'>
                                                        <DatePicker className="datePicker" showTime placeholder='开奖时间' defaultValue={item.lotteryTime ? moment(item.lotteryTime * 1000) : null} format="YYYY-MM-DD HH:mm:ss" onChange={this.onSearchDateChange.bind(this, index)} />
                                                    </div>

                                                    <Input className='articleId' value={item.articleId} onChange={this.InputItemChange.bind(this, index, '-1', 'articleId')} placeholder="请输入绑定的文章ID"></Input>
                                                    <Button type="primary" onClick={this.phaseEdit.bind(this, index)}>保存</Button>
                                                </div>
                                                {
                                                    item.prizeList.length > 0 && item.prizeList[0].prizeId &&
                                                    <div className='drawModel'>
                                                        {
                                                            // pushUrl &&
                                                            <div className='pushUrl'>
                                                                <Button type="primary" size='large' className='copyText' onClick={this.copyText.bind(this, index)}>复制推流地址</Button>
                                                                <span id='pushUrl'>{pushUrl}</span>
                                                            </div>
                                                        }
                                                        <Button className='phaseLotteryAction' onClick={this.phaseLotteryAction.bind(this, index, 1)}>启动摇号</Button>
                                                        {
                                                            item.prizeList.map((prizeListItem, prizeListIndex) => {
                                                                return (
                                                                    <div className='prizeItem' key={prizeListIndex}>
                                                                        <div className='prizeLevelName'>{prizeListItem.prizeLevelName}</div>
                                                                        <Button className='prizeItemInput' onClick={this.startLottery.bind(this, index, prizeListIndex, true)}>抽取</Button>
                                                                        <Button className='prizeItemInput' onClick={this.startLottery.bind(this, index, prizeListIndex, false)}>抽取下一名</Button>
                                                                        {
                                                                            prizeListItem.lotteryNoList && prizeListItem.lotteryNoList.length > 0 &&
                                                                            prizeListItem.lotteryNoList.map((lotteryNoListItem, lotteryNoListIndex) => {
                                                                                return (
                                                                                    <div className='lotteryNoListItem' key={lotteryNoListIndex}>
                                                                                        <Input className='prizeName' value={lotteryNoListItem} disabled placeholder="???????" />
                                                                                        {
                                                                                            lotteryNoListItem.length != 7 &&
                                                                                            <Button onClick={this.submitLotteryNum.bind(this, lotteryNoListItem, prizeListItem.prizeId, index, prizeListIndex, lotteryNoListIndex)}>确定第{lotteryNoListItem.length + 1}位</Button>
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                        {
                                                                            !prizeListItem.lotteryNoList &&
                                                                            <div className='lotteryNoListItem'>
                                                                                <Input className='prizeName' disabled placeholder="???????" />
                                                                                <Button onClick={this.submitLotteryNum.bind(this, '', prizeListItem.prizeId, index, prizeListIndex, -1)}>确定第1位</Button>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <Button className='phaseLotteryAction' onClick={this.phaseLotteryAction.bind(this, index, '0')}>抽奖完成</Button>
                                                    </div>
                                                }
                                            </div>
                                        </TabPane>
                                    )
                                })
                            }
                        </Tabs>
                    }

                </div>
            </ConfigProvider>
        )
    }
}

export default LiveInfoList;